export namespace TrellisConstants {
  export const TestIds = {
    Grid: {
      carrierName: 'col-carrier-name',
      carrierRtIcon: 'claim-realtime-carrier-icon',
    },
  }
}
